export  default {
  plan: '',
  profilesCount: 0,
  additionalUsers: 0,
  additionalProfiles: 0,
  prolongMonths: 1,
  promocode: '',
  discount: '0',
  disablePromocode: false,
  paymentMethod: 'unlimint',
  countryCode: null
}